import { Icons } from '@agro-club/agroclub-shared'
import { ProfileType, User } from 'modules/domain/user/types'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'
import { AButton } from 'views/components/Analytics'
import UserRoutes from 'views/pages/User/routes'
import { Separator, WrapperButton } from './styled'

type Props = {
  user: User
  setBidModal: (arg: boolean) => void
  setEditUserModal: (arg: boolean) => void
  setTaskModal: (arg: boolean) => void
}

export const HeaderControls = ({ setEditUserModal, setTaskModal, setBidModal, user }: Props) => {
  const { t } = useTranslation('user')
  const addButtonText =
    user.profile?.profile_type === ProfileType.customer ? t('bid:form.buyerAddBid') : t('bid:form.add')

  return (
    <WrapperButton>
      <AButton
        id="add"
        Icon={Icons.IconAdd}
        color="approve"
        size="medium"
        onClick={() => setBidModal(true)}
        disabled={!user.is_active}
      >
        {addButtonText}
      </AButton>
      <Separator />
      <AButton id="priceUpdate" color="secondary" size="medium" to={generatePath(UserRoutes.BidPrice, { id: user.id })}>
        {t('priceUpdating')}
      </AButton>
      <AButton id="edit" color="secondary" size="medium" onClick={() => setEditUserModal(true)}>
        {t('common:edit')}
      </AButton>
      <AButton id="setTask" color="secondary" size="medium" onClick={() => setTaskModal(true)}>
        {t('common:setTask')}
      </AButton>
    </WrapperButton>
  )
}
